import script from "./ImportPersons.vue?vue&type=script&setup=true&lang=js"
export * from "./ImportPersons.vue?vue&type=script&setup=true&lang=js"

import "./ImportPersons.vue?vue&type=style&index=0&id=9e27dc18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e27dc18"]])

export default __exports__